import { CajaApertura } from "@/shared/types/caja-apertura";
import { Stack, StackProps } from "@mui/material";
import { Dialog, ModalHeader, useOpenModal } from "@/components/modal";
import ViewCajaActualAperturaMovimientos from "./view-caja-actual-apertura-movimientos";
import SharedViewCajaApertura from "../../shared/components/shared-view-caja-apertura";

export interface ViewCajaActualAperturaProps extends StackProps {
    cajaApertura: CajaApertura
}

export default function ViewCajaActualApertura({
    cajaApertura,
    ...props
}: ViewCajaActualAperturaProps) {
    const openModal = useOpenModal();

    return <Stack gap={3} {...props}>
        <SharedViewCajaApertura cajaApertura={cajaApertura} onViewMovimientosClick={() => openModal("viewAperturaMovimientos")} />
        <Dialog code="viewAperturaMovimientos" size="lg" fullHeight>
            <ModalHeader>Ver Movimientos de Caja</ModalHeader>
            <ViewCajaActualAperturaMovimientos
                cajaApertura={cajaApertura}
                padding={3}
                flex={1}
            />
        </Dialog>
    </Stack>
}